import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { HiX } from 'react-icons/hi';
import TextInput from '@components/forms/TextInput';
import AlertBox from '../../../components/ui/AlertBox';
import { useUniversities } from '../../../contexts/UniversityContext';
import Button from '../../../components/ui/Button';
import { toast } from 'sonner';

const UniversityModal = ({ isOpen, onClose, currentUniversity }) => {
  const { addUniversity, editUniversity } = useUniversities();
  const { register, handleSubmit, reset, formState: { errors, isSubmitting } } = useForm();
  const [submitError, setSubmitError] = useState(null);

  useEffect(() => {    
    if (currentUniversity) {
      reset(currentUniversity);
    } else {
      reset({
        name: ''
      });
    }
  }, [currentUniversity, reset]);

  const onSubmit = async (data) => {
    try {
      if (currentUniversity) {
        await editUniversity(currentUniversity.id, data);
        toast.success('University updated successfully');
      } else {
        await addUniversity(data);
        toast.success('University added successfully')
      }
      onClose();
    } catch (error) {
      setSubmitError('Something went wrong. Please try again.');
    }
  };

  return (
    <div className={`modal ${isOpen ? 'modal-open' : ''}`}>
      <div className="modal-box">
        <label className="absolute right-4 top-4">
          <HiX className="h-6 w-6 cursor-pointer" onClick={onClose} />
        </label>
        <h3 className="font-semibold text-lg mb-4">{currentUniversity ? "Edit University" : "Add New University"}</h3>
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          {submitError && <AlertBox message={submitError} type="error" />}
          <TextInput
            label="University Name"
            name="name"
            type="text"
            placeholder="Enter university name"
            register={register}
            errors={errors}
            validationRules={{ required: 'University name is required' }}
          />
          <div className="modal-action">
            <Button isLoading={isSubmitting} type="submit">
              {currentUniversity ? "Update" : "Create"} University
            </Button>
            <button type="button" className="btn btn-ghost" onClick={onClose}>
              Cancel
            </button>
          </div>
        </form>
      </div>
      <div className="modal-backdrop" onClick={onClose}>
        <button className="">Close</button>
      </div>
    </div>
  );
};

export default UniversityModal;
